export default __webpack_public_path__ + "static/poster-ff6e2e66b37e51ca0219746b091c3c9f.png";